import { render } from "./Footer-index.vue?vue&type=template&id=9f09ad62"
import script from "./Footer-index.vue?vue&type=script&lang=js"
export * from "./Footer-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__